// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ResourcePermissionSchema = z.object({
  resource: z.coerce.string().describe("Resource name (e.g., user, project, hour)"),
  permissions: z.object({}).describe("Permissions per role. Keys are role IDs, values are arrays of permitted operations."),
});
